module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-4@2x-43f2baa436cc90f2a5b7246bbcc0d924.png";